import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_fleche_gaucheUrl, id_fleche_gaucheId, id_fleche_gaucheAlt, id_fleche_gaucheOpacite, id_fleche_gaucheAfficher, id_fleche_droiteUrl, id_fleche_droiteId, id_fleche_droiteAlt, id_fleche_droiteOpacite, id_fleche_droiteAfficher, blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="fleche-gauche (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_fleche_gaucheAfficher}
                        onChange={(val) => setAttributes({ id_fleche_gaucheAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_fleche_gaucheAlt}
                            onChange={(val) => setAttributes({ id_fleche_gaucheAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_fleche_gaucheOpacite}
                        onChange={(val) => setAttributes({ id_fleche_gaucheOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="fleche-droite (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_fleche_droiteAfficher}
                        onChange={(val) => setAttributes({ id_fleche_droiteAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_fleche_droiteAlt}
                            onChange={(val) => setAttributes({ id_fleche_droiteAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_fleche_droiteOpacite}
                        onChange={(val) => setAttributes({ id_fleche_droiteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="container-fluid">
                    {/* id_titre_1 */}
                    <div className="row">
                        <div className="col-12">
                            {id_titre_1Afficher && (
                                <RichText 
                                    tagName="h1" 
                                    className="id_titre_1 " 
                                    value={id_titre_1Texte} 
                                    onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                                />
                            )}
                        </div>
                    </div>
                    {/* end-id_titre_1 */}
                    {/* id_paragraphe_1 */}
                    <div className="row">
                        <div className="col-12">
                            {id_paragraphe_1Afficher && (
                                <RichText 
                                    tagName="p" 
                                    className="id_paragraphe_1 " 
                                    value={id_paragraphe_1Texte} 
                                    onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                                />
                            )}
                        </div>
                    </div>
                    {/* end-id_paragraphe_1 */}
                    {/* id_fleche_gauche */}
                    {id_fleche_gaucheAfficher && (
                        <MediaUpload
                            onSelect={(media) => setAttributes({ id_fleche_gaucheUrl: media.url, id_fleche_gaucheId: media.id })}
                            type="image"
                            value={id_fleche_gaucheId}
                            render={({ open }) => (
                                <div onClick={open} style={{ cursor: 'pointer' }}>
                                    {id_fleche_gaucheUrl ? (
                                        <img className="id_fleche_gauche" src={id_fleche_gaucheUrl} alt={id_fleche_gaucheAlt} style={{ opacity: id_fleche_gaucheOpacite }} />
                                    ) : (
                                        <Button variant="secondary">Ajouter une image</Button>
                                    )}
                                </div>
                            )}
                        />
                    )}
                    {/* end-id_fleche_gauche */}
                    {/* id_fleche_droite */}
                    {id_fleche_droiteAfficher && (
                        <MediaUpload
                            onSelect={(media) => setAttributes({ id_fleche_droiteUrl: media.url, id_fleche_droiteId: media.id })}
                            type="image"
                            value={id_fleche_droiteId}
                            render={({ open }) => (
                                <div onClick={open} style={{ cursor: 'pointer' }}>
                                    {id_fleche_droiteUrl ? (
                                        <img className="id_fleche_droite" src={id_fleche_droiteUrl} alt={id_fleche_droiteAlt} style={{ opacity: id_fleche_droiteOpacite }} />
                                    ) : (
                                        <Button variant="secondary">Ajouter une image</Button>
                                    )}
                                </div>
                            )}
                        />
                    )}
                    {/* end-id_fleche_droite */}
                    <div className="row justify-content-center align-items-stretch">
                        {/* id_article_1 */}
                        <div className="col-12 col-md-6 col-lg-4 d-flex">
                            <article>
                                {/* id_article_1_titre_article */}
                                <h2 id="id_article_1_titre_article">
attribut_id_article_1_titre_article_texte
                                </h2>
                                {/* end-id_article_1_titre_article */}
                                {/* id_article_1_date_article */}
                                <p id="id_article_1_date_article">
attribut_id_article_1_date_article_texte
                                </p>
                                {/* end-id_article_1_date_article */}
                                {/* id_article_1_extrait_article */}
                                <p id="id_article_1_extrait_article">
attribut_id_article_1_extrait_article_texte
                                </p>
                                {/* end-id_article_1_extrait_article */}
                                {/* id_article_1_image_article */}
                                <img id="id_article_1_image_article" src="attribut_id_article_1_image_article_src" alt="attribut_id_article_1_image_article_alt" />
                                {/* end-id_article_1_image_article */}
                                {/* id_article_1_bouton_lecture_article */}
                                <a href="attribut_id_article_1_bouton_lecture_article_lien" id="id_article_1_bouton_lecture_article" className="btn" role="button">
                                    {/* id_article_1_bouton_lecture_article_texte_1 */}
                                    <span id="id_article_1_bouton_lecture_article_texte_1">
attribut_id_article_1_bouton_lecture_article_texte_1_texte
                                    </span>
                                    {/* end-id_article_1_bouton_lecture_article_texte_1 */}
                                </a>
                                {/* end-id_article_1_bouton_lecture_article */}
                            </article>
                        </div>
                        {/* end-id_article_1 */}
                        {/* id_article_2 */}
                        <div className="col-12 col-md-6 col-lg-4 d-flex d-none d-md-flex">
                            <article>
                                {/* id_article_2_titre_article */}
                                <h2 id="id_article_2_titre_article">
attribut_id_article_2_titre_article_texte
                                </h2>
                                {/* end-id_article_2_titre_article */}
                                {/* id_article_2_date_article */}
                                <p id="id_article_2_date_article">
attribut_id_article_2_date_article_texte
                                </p>
                                {/* end-id_article_2_date_article */}
                                {/* id_article_2_extrait_article */}
                                <p id="id_article_2_extrait_article">
attribut_id_article_2_extrait_article_texte
                                </p>
                                {/* end-id_article_2_extrait_article */}
                                {/* id_article_2_image_article */}
                                <img id="id_article_2_image_article" src="attribut_id_article_2_image_article_src" alt="attribut_id_article_2_image_article_alt" />
                                {/* end-id_article_2_image_article */}
                                {/* id_article_2_bouton_lecture_article */}
                                <a href="attribut_id_article_2_bouton_lecture_article_lien" id="id_article_2_bouton_lecture_article" className="btn" role="button">
                                    {/* id_article_2_bouton_lecture_article_texte_1 */}
                                    <span id="id_article_2_bouton_lecture_article_texte_1">
attribut_id_article_2_bouton_lecture_article_texte_1_texte
                                    </span>
                                    {/* end-id_article_2_bouton_lecture_article_texte_1 */}
                                </a>
                                {/* end-id_article_2_bouton_lecture_article */}
                            </article>
                        </div>
                        {/* end-id_article_2 */}
                        {/* id_article_3 */}
                        <div className="col-12 col-md-6 col-lg-4 d-flex d-none d-lg-flex">
                            <article>
                                {/* id_article_3_titre_article */}
                                <h2 id="id_article_3_titre_article">
attribut_id_article_3_titre_article_texte
                                </h2>
                                {/* end-id_article_3_titre_article */}
                                {/* id_article_3_date_article */}
                                <p id="id_article_3_date_article">
attribut_id_article_3_date_article_texte
                                </p>
                                {/* end-id_article_3_date_article */}
                                {/* id_article_3_extrait_article */}
                                <p id="id_article_3_extrait_article">
attribut_id_article_3_extrait_article_texte
                                </p>
                                {/* end-id_article_3_extrait_article */}
                                {/* id_article_3_image_article */}
                                <img id="id_article_3_image_article" src="attribut_id_article_3_image_article_src" alt="attribut_id_article_3_image_article_alt" />
                                {/* end-id_article_3_image_article */}
                                {/* id_article_3_bouton_lecture_article */}
                                <a href="attribut_id_article_3_bouton_lecture_article_lien" id="id_article_3_bouton_lecture_article" className="btn" role="button">
                                    {/* id_article_3_bouton_lecture_article_texte_1 */}
                                    <span id="id_article_3_bouton_lecture_article_texte_1">
attribut_id_article_3_bouton_lecture_article_texte_1_texte
                                    </span>
                                    {/* end-id_article_3_bouton_lecture_article_texte_1 */}
                                </a>
                                {/* end-id_article_3_bouton_lecture_article */}
                            </article>
                        </div>
                        {/* end-id_article_3 */}
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}